import { render } from "./Mail.vue?vue&type=template&id=6537155a"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
script.render = render

export default script